import { useEffect, useState } from 'react'

import { EVENT_NAME_RESIZE } from '../../../../../constants/event'

import { getChatroomInputWysiwygMaxHeight } from './useChatroomInputWysiwygMaxHeight.utils'

export function useChatroomInputWysiwygMaxHeight(isFullScreen) {
  const [maxHeight, setMaxHeight] = useState(() =>
    getChatroomInputWysiwygMaxHeight(isFullScreen)
  )

  useEffect(() => {
    function handleResize() {
      setMaxHeight(getChatroomInputWysiwygMaxHeight(isFullScreen))
    }

    handleResize()

    window.addEventListener(EVENT_NAME_RESIZE, handleResize)

    return () => {
      window.removeEventListener(EVENT_NAME_RESIZE, handleResize)
    }
  }, [isFullScreen])

  return maxHeight
}
